export const GOLD_GAMES_HISTORY_STATUS = {
  PENDING: 'pending',
  AWARDING: 'awarding',
  AWARDED: 'awarded',
  UNKNOWN: 'unknown',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
} as const;

export type GoldGamesHistoryStatus = (typeof GOLD_GAMES_HISTORY_STATUS)[keyof typeof GOLD_GAMES_HISTORY_STATUS];

export const GOLD_GAMES_HISTORY_STATUS_OPTIONS = [
  { id: '', name: 'All statuses' },
  { id: GOLD_GAMES_HISTORY_STATUS.PENDING, name: 'Pending' },
  { id: GOLD_GAMES_HISTORY_STATUS.AWARDING, name: 'Awarding' },
  { id: GOLD_GAMES_HISTORY_STATUS.AWARDED, name: 'Awarded' },
  { id: GOLD_GAMES_HISTORY_STATUS.UNKNOWN, name: 'Unknown' },
  { id: GOLD_GAMES_HISTORY_STATUS.CANCELLED, name: 'Cancelled' },
  { id: GOLD_GAMES_HISTORY_STATUS.EXPIRED, name: 'Expired' },
];
